import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import Sticky from 'react-stickynode';

/* Components */
import { FilterButton } from 'site-modules/shared/components/inventory/filters-button/filters-button';
import { SemanticSearch } from 'site-modules/shared/components/inventory/semantic-search/semantic-search';

import './srp-query-input.scss';

const INPUT_HEADER = 'Describe what you’re looking for';
const SHOP_5067_SUBMIT_BUTTON_CLASS =
  'srp-query-input-submit-btn pos-a d-flex justify-content-center align-items-center bg-green-50 shop-5067-srp-top-submit-btn';
const SHOP_5067_QUERY_INPUT_STYLE = { paddingTop: '20px' };
const SHOP_5067_SEARCH_FORM_STYLE = { height: '48px', minHeight: '48px', marginBottom: 0 };

export function SrpQueryInput({
  onFiltersBtnClick = noop,
  activeFiltersCount = 0,
  isMobile = false,
  YMMTPlaceholder = '',
  dynamicPlaceholderSuggestions = [],
  dealerId = undefined,
  disableLlm = false,
  onApplyFilterToUrl = noop,
  selectedFacets = {},
  isShop5067Challenger = false,
}) {
  const [isSticky, setIsSticky] = useState(false);

  const handleStateChange = useCallback(({ status }) => {
    setIsSticky(status === Sticky.STATUS_FIXED);
  }, []);

  return (
    <div
      className={classnames(isShop5067Challenger ? 'px-1 pt-1_25' : 'px-1 pt-1 pb-1 pb-md-0_5', {
        'srp-query-input bg-white': !isShop5067Challenger && (!disableLlm || (disableLlm && isMobile)),
        'shop-5067-srp-top-query-input': isShop5067Challenger,
        'pt-1': disableLlm && !isMobile,
      })}
      style={isShop5067Challenger ? SHOP_5067_QUERY_INPUT_STYLE : undefined}
    >
      {!disableLlm && (
        <>
          {!isShop5067Challenger && (
            <div className="mb-0_5 d-flex">
              <h2 className="text-cool-gray-10 fw-bold mb-0 size-20">{INPUT_HEADER}</h2>
            </div>
          )}
          <Sticky
            enabled={!isMobile}
            activeClass="sticky-form-active"
            className="sticky-form"
            onStateChange={handleStateChange}
          >
            <div className={classnames({ container: isSticky })}>
              <SemanticSearch
                isMobile={isMobile}
                YMMTPlaceholder={YMMTPlaceholder}
                dynamicPlaceholderSuggestions={dynamicPlaceholderSuggestions}
                isSticky={isSticky}
                onFiltersBtnClick={onFiltersBtnClick}
                dealerId={dealerId}
                autosizeOnFocus
                searchFormClassName={
                  isShop5067Challenger ? 'srp-query-input-form pos-r shop-5067-srp-top-search-form' : undefined
                }
                searchFormStyle={isShop5067Challenger ? SHOP_5067_SEARCH_FORM_STYLE : undefined}
                submitButtonClassName={isShop5067Challenger ? SHOP_5067_SUBMIT_BUTTON_CLASS : undefined}
                onApplyFilterToUrl={onApplyFilterToUrl}
                selectedFacets={selectedFacets}
              />
            </div>
          </Sticky>
        </>
      )}
      {!isShop5067Challenger && (
        <FilterButton
          onFiltersBtnClick={onFiltersBtnClick}
          activeFiltersCount={activeFiltersCount}
          classes="d-lg-none w-100 justify-content-center my-md-0_5"
        />
      )}
    </div>
  );
}

SrpQueryInput.propTypes = {
  onFiltersBtnClick: PropTypes.func,
  activeFiltersCount: PropTypes.number,
  YMMTPlaceholder: PropTypes.string,
  dynamicPlaceholderSuggestions: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
  dealerId: PropTypes.string,
  disableLlm: PropTypes.bool,
  onApplyFilterToUrl: PropTypes.func,
  selectedFacets: PropTypes.shape({}),
  isShop5067Challenger: PropTypes.bool,
};
